module.exports = __webpack_public_path__ + "img/code.984fe344.png";